import {Injectable} from '@angular/core';
import {DaoGeneric} from "@Services/base/daoService";
import {environment} from "@Env/environment";
import {HttpClient} from "@angular/common/http";
import {Document} from "app/archivage/common/services/document/document.model";
import {Bel} from "../bel/bel/bel.model";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DocumentService extends DaoGeneric<Document> {
  private url = `${environment.baseUrl}/api_archive/document/`;
  readonly finalFate: string[] = [];

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  getTotalDocWoDua() {
    const url = `${this.url}documents_without_dua_total`;
    return this.httpClient.get(url);
  }

  massUpdate(bel: Bel, docsList: number[], check_all: boolean): Observable<Bel> {
    const url = `${this.url}${bel.id}/mass_update/`;
    return this.httpClient.post<Bel>(url, {check_all: check_all, docs_list: docsList})
  }
}
